import VueX from "vuex"
import Vue from "vue"
import http from "@/http.js"
import moment from 'moment'

Vue.use(VueX)

const state = {
    tariffs: {},
    towns: [],
}

const mutations = {
  setTariffs(state, data) { state.tariffs = data },
  setTowns(state, data) { state.towns = data },
}
 
const actions = {

    loadTariffs: async function(ctx)
    {
      const resp = await fetch(`${process.env.VUE_APP_SERVER}/api/meta/tariff`)
      const tariffs = await resp.json()
      ctx.commit("setTariffs", tariffs)
     },

    loadTowns: async function(ctx)
    {
      const resp = await fetch(`${process.env.VUE_APP_SERVER}/api/meta/towns`)
      const towns = await resp.json()
      ctx.commit("setTowns", towns)
     },

     login: async function(ctx, {login,password})
     {
      const formData  = new FormData();
      formData.append("login", login);
      formData.append("password", password);
     
      try
      {
        const resp = await fetch(`${process.env.VUE_APP_SERVER}/api/token`,
        {
          method: 'POST',
          body: formData,
        })
        
        if(resp.ok)
        {
          const {token, expires} = await resp.json()
          const exp = moment(expires).unix()

          sessionStorage.setItem("expires", exp);
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("login", login);
          sessionStorage.setItem("password", password);

          return null
        }
        else
        {
          const ctype = resp.headers.get("Content-Type");
          if (ctype && (ctype.match(/^application\/json/) || ctype.match(/^application\/error\+json/)))
          {
            const status = await resp.json()
            return status.humanText
          }
          else
          {
            const error = await resp.text()
            return error
          }
        }
      } catch(error)
      {
        return error
      }
     },
     
     getToken: async function(ctx)
     {
        const exp = sessionStorage.getItem("expires")
        const token = sessionStorage.getItem("token")
        
        const now = moment().unix()
        if (now < exp-300) return token
        
        const login = sessionStorage.getItem("login")
        const password = sessionStorage.getItem("password")

        if (!login || !password)
        {
          console.log("акция getToken: нет логина и пароля в хранилище")
          return null
        }
        
        await ctx.dispatch("login", {login, password})
        return sessionStorage.getItem("token")
     },
     
     logout: async function(ctx)
     {
       sessionStorage.removeItem("expires");
       sessionStorage.removeItem("token");
       sessionStorage.removeItem("login");
       sessionStorage.removeItem("password");
     }

} 

export default new VueX.Store({
    state,
    mutations,
    actions,
 })